
import styled from "styled-components";

export const GameBadgeFlipperFront = styled.div`
    position: absolute;
    width: 100%;
    height: 100%;
    backface-visibility: hidden;

    img {
        width: 100%;
        height: 100%;
    }
`;
